import { AgreementPage } from '@/page-content/agreement';
export default AgreementPage;